export default {
  title: {
    en: 'You\'ve added a premium product',
  },
  additionalPrice: {
    en: 'This product costs an additional {price}',
  },
  forFreeMonth: {
    en: `
      You also have a free credit of Scentbird, which means your account will
      only reflect the premium product surcharge {price}.
    `,
  },
  checkboxLabel: {
    en: 'Do not show me this message again',
  },
  buttonTitle: {
    en: 'Got It!',
  },
  subText: {
    en: 'No, I don\'t want to add this product to queue',
  },
}
